import React from 'react';
import { range } from 'ramda';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { t } from '../../../../../../modules/infra/i18n';

import { tierKeyNameShape } from '../../shapes';
import { fullName } from '../../../../../common/helpers/users';
import CurrencyInput from '../../../../../common/currencyInput';
import PercentageInput from '../../../../../common/percentageInput';

const tiers = range(1, 6);

const PercentageForm = props => {
  return (
    <ReactTable
      data={props.barbers}
      showPagination={false}
      defaultPageSize={10000}
      minRows={0}
      className="c-table-new c-no-hover c-shop-commissions-table c-shop-commissions-table--percentage"
      sortable={false}
      getTdProps={() => ({
        className: 'u-p-0',
      })}
      getTheadThProps={() => ({
        className: 'u-p-0',
      })}
      columns={[
        {
          Header: null,
          Cell: ({ original }) => fullName(original),
        },
        ...tiers.map((tier, tierIndex) => ({
          Header: () => (
            <div className="u-text-center">{t('settings:commission.tier_header')} {tier}</div>
          ),
          Cell: ({ index }) => (
            <div className="o-flexbox u-justify-content-space-between u-width-100">
              <CurrencyInput
                disabled={props.disabled}
                name={`barbers.${index}.${props.tierKeyName}.${tierIndex}.amount`}
                className="c-input u-mr- u-width-75"
                parse={value => value && Number(value)}
              />
              <PercentageInput
                disabled={props.disabled}
                name={`barbers.${index}.${props.tierKeyName}.${tierIndex}.percentage`}
                className="c-input u-width-75"
                parse={value => value && Number(value)}
              />
            </div>
          ),
        })),
      ]}
    />
  );
};

PercentageForm.propTypes = {
  barbers: PropTypes.array.isRequired,
  tierKeyName: tierKeyNameShape.isRequired, // eslint-disable-line react/no-unused-prop-types
  disabled: PropTypes.bool.isRequired,
};

export default PercentageForm;
